import React from "react";
import { useLocation } from "react-router-dom";
import { X } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { navigationItems } from "./navigation";

interface PortalSidebarProps {
    isMobileOpen?: boolean;
    onClose?: () => void;
}

// Mobile / tablet navigation drawer. On desktop the same links sit in the top bar.
export const PortalSidebar: React.FC<PortalSidebarProps> = ({ isMobileOpen = false, onClose }) => {
    const { t } = useLanguage();
    const location = useLocation();

    return (
        <aside className={cn("portal-sidebar", isMobileOpen && "mobile-open")}>
            <div className="flex items-center justify-between px-5 pt-5 pb-3">
                <img
                    src="/uploads/a0faf86a-8d67-40e8-8452-60261fdb6d9b.png"
                    alt="WSM Logo"
                    className="h-12 w-14 object-contain"
                />
                <Button variant="ghost" size="sm" onClick={onClose} className="h-10 w-10 p-0">
                    <X className="h-5 w-5" />
                </Button>
            </div>

            <nav className="flex-1 space-y-1 px-3">
                {navigationItems.map((item) => {
                    const Icon = item.icon;
                    const active = location.pathname === item.href;

                    return (
                        <a
                            key={item.key}
                            href={item.href}
                            className={cn(
                                "flex items-center gap-3 h-12 px-4 rounded-2xl text-[15px] font-medium transition-colors",
                                active
                                    ? "bg-ink text-white"
                                    : "text-muted-foreground hover:bg-muted hover:text-foreground"
                            )}
                        >
                            <Icon className={cn("h-5 w-5 shrink-0", active && "text-primary")}/>
                            {t(item.key)}
                        </a>
                    );
                })}
            </nav>

            <div className="px-5 py-4 text-xs text-muted-foreground border-t border-border">
                <p>© 2025 WSM</p>
                <p>الإصدار 1.0.0</p>
            </div>
        </aside>
    );
};
